module.exports = __webpack_public_path__ + "static/media/ship-1.a85b06f5.jpg";